import React from 'react';
import classes from './Loader.module.scss';
import LoaderSpin from 'react-loader-spinner';

class Loader extends React.Component {
    // constructor(props) {
    //     super(props);
    //
    // }

    componentDidMount() {
        // console.log('loader-cls',classes)
    }

    render() {
        return (
            <div className={`${classes.container} ${this.props.className ? this.props.className : ''}`}>
                    <LoaderSpin
                        type="ThreeDots"
                        color={this.props.color ? this.props.color : '#000'}
                    />
            </div>
        );
    }
}

export default Loader;


// example for using with overlay::
//     <div className={'loaderContainer'}>
//         {
//             loading ?
//                 <div className={'loaderOverlay'}>
//                     <Loader/>
//                 </div>
//                 :
//                 null
//         }
//     </div>
